import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { DataService } from "src/app/common/services/data/data.service";
// import { ApiEndpoint } from "./api.endpoints";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(public data: DataService) {}

gettoken(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('authenticate/gettoken', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
authenticateuser(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/authenticateuser', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getJWT(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/GenerateJWT', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
authenticateitguser(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/authenticateitguser', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
forgotuserpassword(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/forgotuserpassword', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
forgotuserid(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/forgotuserid', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewuserprofile(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('authenticate/createnewuserprofile', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
registeruserprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/registeruserprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
resetuserpassword(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/resetuserpassword', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getuserdetailsfromurl(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/getuserdetailsfromurl', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveuserpassword(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/saveuserpassword', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
decryptuserdata(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/decryptuserdata', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
changeuserpassword(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('authenticate/ChangeUserPassword', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getcustomerinitialdataaddress(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/getcustomerinitialdataaddress', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
createnewcustomeraddress(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/createnewcustomeraddress', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
savecustomeraddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/savecustomeraddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getquestion(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/getquestion', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveaddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/saveaddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadislandbasedonprovince(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadislandbasedonprovince', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadlocationbasedonprovince(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadlocationbasedonprovince', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadareabasedonlocation(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadareabasedonlocation', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadtikinabasedonprovince(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadtikinabasedonprovince', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadvillagebasedontikina(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadvillagebasedontikina', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
loadactivecoperativeorganization(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/loadactivecoperativeorganization', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
openimage(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/images/{DocumentId}/{OrgCode}', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
opendocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/opendocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
opendocumentMobile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/opendocumentMobile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadDefaultLandingPage(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loaddefaultlandingpage', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getLaunchInfo(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/getlaunchinfo', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
setLaunchInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/setlaunchinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
openorganizationlogo(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/logo/{OrgCode}', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
downloaddocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/downloaddocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
sendotpforgetpinorpasswordorusername(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/sendotpforgetpinorpasswordorusername', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
validateotpforgetpinorpasswordorusername(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/validateotpforgetpinorpasswordorusername', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openorgbasedproductdetails(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/openorgbasedproductdetails', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openperapplicationgrouporglink(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/openperapplicationgrouporglink', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadalltikina(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadalltikina', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadtikinabasedonprovinceanddate(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/loadtikinabasedonprovinceanddate', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
checkIfProductEndDateOccurs(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/CheckIfProductEndDateOccurs', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openaddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/openaddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomerPayoutReportInCoOperatives(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/CreateCustomerPayoutReportInCoOperatives', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
searchCustomerPayoutReportInCoOperatives(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/SearchCustomerPayoutReportInCoOperatives', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
loadactiveinsurnaceorganization(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('common/loadactiveinsurnaceorganization', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
sumbitDemoScheduleDetails(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('common/SumbitDemoScheduleDetails', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getcustomerapplictioninitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customerapplication/getcustomerapplictioninitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getcustomerapplicationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customerapplication/getcustomerapplicationsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
customerapplicationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/customerapplicationsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openCustomerapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/openCustomerapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
downloadCustomerDetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/downloadCustomerDetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
downloadSearchBasedCustomerDetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/DownloadSearchBasedCustomerDetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getAllQuestionBasedOnGroupForCustomerApplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/getallquestionbasedongroupforcustomerapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
cancelCustomerApplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/cancelcustomerapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadCertificateForCustomerApplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/UploadCertificateForCustomerApplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
updateCustomerApplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/UpdateCustomerApplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
updateCACustomerInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/UpdateCACustomerInfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
updateCustomerApplicationDocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customerapplication/UpdateCustomerApplicationDocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getcustomerinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getcustomerinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
createnewcustomer(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/createnewcustomer', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
deletecustomerinfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deletecustomerinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
opencustomerinfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/opencustomerinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getcustomerinfosearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getcustomerinfosearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
customerinfosearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/customerinfosearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createnewasset(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/createnewasset', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveassetprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveassetprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openassetprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openassetprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteassetprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deleteassetprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createnewcredit(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/createnewcredit', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savecreditprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savecreditprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
opencreditprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/opencreditprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deletecreditprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deletecreditprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createnewincome(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/createnewincome', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveincomeprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveincomeprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openincomeprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openincomeprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteincomeprofile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deleteincomeprofile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewquestionresponse(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/createnewquestionresponse', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
savecustomerinfopermanentaddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savecustomerinfopermanentaddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
updateCustomerInfoPermanentAddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/UpdateCustomerInfoPermanentAddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getpreapplicationinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getpreapplicationinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
loadallpreapplicationgroups(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadallpreapplicationgroups', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getproductnamebasedonorgid(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/getproductnamebasedonorgid', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openproductdetailsbyclientcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openproductdetailsbyclientcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadpreapplicationproductbyorgcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadpreapplicationproductbyorgcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getpreapplicationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getpreapplicationsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
preapplicationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/preapplicationsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openpreapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openpreapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewpreapplication(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/createnewpreapplication', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
createNewRevisedPreApplication(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/CreateNewRevisedPreApplication', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
loadAllRevisedPreApplicationGroups(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/LoadAllRevisedPreApplicationGroups', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savepreapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savepreapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
preapplicationmembersearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/preapplicationmembersearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
linkuppreapplicationmemberlist(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/linkuppreapplicationmemberlist', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
delinkpreapplicationmemberlist(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/delinkpreapplicationmemberlist', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
agreepreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/agreepreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
disagreepreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/disagreepreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
cancelpreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/cancelpreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deletepreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deletepreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
viewonboardapplicationfrompreapplicaiton(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/viewonboardapplicationfrompreapplicaiton', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openpreapplicationforconsent(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openpreapplicationforconsent', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
resendmailconsent(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/resendmailconsent', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
agreeMemberConsent(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/agreeMemberConsent', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
disagreememberconsent(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/disagreememberconsent', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
bulkonboadrdapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/bulkonboadrdapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadselectedpreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadselectedpreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadconsentpreapplicationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadconsentpreapplicationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
checkIfEndDateOccursForSelectedProductsByPreAppplicationId(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/checkIfEndDateOccursForSelectedProductsByPreAppplicationId', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deletePreApplicationByPreApplicationId(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/DeletePreApplicationByPreApplicationId', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/createapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getapplicationinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getapplicationinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getapplicationinitialdataforsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getapplicationinitialdataforsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getapplicationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/getapplicationsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
applicationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/applicationsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewapplication(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('customeronboarding/createnewapplication', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
submitapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/submitapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
cancelledapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/cancelledapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/openapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadapplicationdocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/uploadapplicationdocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteapplicationdocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/deleteapplicationdocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savecustomerinfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savecustomerinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveOnboardPersonalInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/SaveOnboardPersonalInfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveONboardKYCInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/SaveONboardKYCInfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveOnboardCommunicationInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/SaveOnboardCommunicationInfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveListOfAsset(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/SaveListOfAsset', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofcreditdetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savelistofcreditdetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofincomedetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savelistofincomedetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofquestionresponse(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savelistofquestionresponse', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getallquestionbasedongroupforapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/getallquestionbasedongroupforapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savequestionresponse(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/savequestionresponse', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadonboardapplicationproductbyorgcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadonboardapplicationproductbyorgcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadpreapplicationbasedorgcodeandproduct(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/loadpreapplicationbasedorgcodeandproduct', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveonboardapplicationsignature(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveonboardapplicationsignature', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveonboardapplicationphoto(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveonboardapplicationphoto', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveotpforonboardapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/saveotpforonboardapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getallquestionresponsebasedonclientcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('customeronboarding/getallquestionresponsebasedonclientcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getmemberregstrationinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmemberregstrationinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
createnewmemberregistration(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/createnewmemberregistration', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
savememberregistraion(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/savememberregistraion', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savememberresetpasswordandpin(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/savememberresetpasswordandpin', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openmemberregistration(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/openmemberregistration', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getmemberinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmemberinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}

getmemberserachinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmembersearchinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
createnewmember(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/createnewmember', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
savemember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/savemember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getmembersearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmembersearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
membersearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/membersearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/openmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deletemember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/deletemember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savememberpermanentaddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/savememberpermanentaddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadmemberlistdocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/uploadmemberlistdocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
downloadsamplememberexcel(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/downloadsamplememberexcel', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getMemberDocumentSearchInitialData(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmemberdocumentsearchinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getmemberdocumentsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/getmemberdocumentsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
memberdocumentsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/memberdocumentsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getmemberloactionverificationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/GetMemberLoactionVerificationSearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
memberloactionverificationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/MemberLoactionVerificationSearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
verifyListOfMemberLocation(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/VerifyListOfMemberLocation', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
verifyMemberLocation(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/VerifyMemberLocation', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
pendingverificationmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/pendingverificationmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
bulkpendingverificationmember(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/bulkpendingverificationmember', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
downloadsearchbasedlocationverification(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/downloadsearchbasedlocationverification', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getLatitudeLongitudeByTikinaValue(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/GetLatitudeLongitudeByTikinaValue', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getLocationVerificationInitialData(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/GetLocationVerificationInitialData', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
downloadCertificateByCooperatives(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/DownloadCertificateByCooperatives', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
downloadCertificateByCooperativesMoblie(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/DownloadCertificateByCooperativesMoblie', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getLatitudeLongitudeByVillageValue(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('member/GetLatitudeLongitudeByVillageValue', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
memberAndProductForGMS(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('member/MemberAndProductForGMS', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
loadallinsuranceproviderorganisation(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('mobile/loadallinsuranceproviderorganisation', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
openallproductbasedonorganization(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/openallproductbasedonorganization', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openproductdetailsbyproductcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/openproductdetailsbyproductcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
validateverificationcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/validateverificationcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savememberregpin(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/savememberregpin', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
memberlogin(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/memberlogin', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
changeuserloginpassword(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/changeuserloginpassword', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
changeuserloginpin(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/changeuserloginpin', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadorganizationusingmemberid(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/loadorganizationusingmemberid', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadapplicationusingmemberid(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/loadapplicationusingmemberid', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openconsent(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/openconsent', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadpreapplicationbasedonmemberidandclientcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/loadpreapplicationbasedonmemberidandclientcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
agreememberconsentformobile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/agreememberconsentformobile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
disagreememberconsentformobile(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/disagreememberconsentformobile', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveresetpasswordformember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/saveresetpasswordformember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveresetpinformember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/saveresetpinformember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createapplicationfrommember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/createapplicationfrommember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadapplicationlistforloginmember(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/loadapplicationlistforloginmember', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openallproductbasedapplication(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/openallproductbasedapplication', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openapplicationusingclientcode(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('mobile/openapplicationusingclientcode', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getorganizationregstrationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationregstrationsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
organizationregstrationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/organizationregstrationsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createneworganizationregistration(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createneworganizationregistration', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
openorganizationregistration(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/openorganizationregistration', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveorganizationregistraion(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationregistraion', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
approveorrejectorganizationregistraion(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/approveorrejectorganizationregistraion', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getorganizationinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getorganizationsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
organizationsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/organizationsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createneworganization(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createneworganization', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveorganization(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganization', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openorganization(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/openorganization', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getuserinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getuserinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getusersearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getusersearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
usersearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/usersearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openuser(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/openuser', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewuser(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createnewuser', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveorganizationuser(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationuser', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveuser(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveuser', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
addlistofusergroup(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/addlistofusergroup', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
addlistofuserbranchlink(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/addlistofuserbranchlink', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveusergroup(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveusergroup', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofusergroup(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savelistofusergroup', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveuserbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveuserbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofuserbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savelistofuserbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getorganizationbranchinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationbranchinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getorganizationbranchsearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationbranchsearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
organizationbranchsearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/organizationbranchsearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createneworganizationbranch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createnewOrganizationBranch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveorganizationbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savebranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savebranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteorganizationbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/deleteorganizationbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openorganizationbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/openorganizationbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savebranchaddress(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savebranchaddress', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
adduserinorganizationbranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/adduserinorganizationbranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistofuserfrombranch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savelistofuserfrombranch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getorganizationproductinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/getorganizationproductinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
 
getOrganizationProductSearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/GetOrganizationProductSearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
organizationProductSearch(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/OrganizationProductSearch', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createneworganizationproduct(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createneworganizationproduct', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveorganizationproduct(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationproduct', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveproduct(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveproduct', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteorganizationproduct(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/deleteorganizationproduct', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openorganizationproduct(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/openorganizationproduct', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveorganizationproductimages(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationproductimages', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteorganizationproductimages(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/deleteorganizationproductimages', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
saveorganizationproductdocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationproductdocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
deleteorganizationproductdocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/deleteorganizationproductdocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
savelistoforganizationproductimage(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/savelistoforganizationproductimage', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openOrgformVariousDB(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/OpenOrgformVariousDB', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewproductPremiumdetails(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('organization/createnewproductPremiumdetails', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveorganizationproductpremiumdetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/saveorganizationproductpremiumdetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openProductPremiumDetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('organization/OpenProductPremiumDetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getmemberreportinitialdata(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Report/getmemberreportinitialdata', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
createnewmemberreport(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Report/createnewmemberreport', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
generatememberregistrationreport(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Report/generatememberregistrationreport', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
generateMemberRegistrationExcel(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Report/GenerateMemberRegistrationExcel', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomer(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateCustomer', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveCustomer(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SaveCustomer', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openCustomer(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/OpenCustomer', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomerPolicy(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateCustomerPolicy', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveCustomerPolicy(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SaveCustomerPolicy', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openCustomerPolicy(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/OpenCustomerPolicy', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomerPolicyPayout(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateCustomerPolicyPayout', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveCustomerPolicyPayout(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SaveCustomerPolicyPayout', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createWrmsEventInfo(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateWrmsEventInfo', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveWrmsEventInfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SaveWrmsEventInfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createWrmsEventInfoDetail(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateWrmsEventInfoDetail', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
saveWrmsEventInfoDetail(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SaveWrmsEventInfoDetail', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createnewwrmseventinfosearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/createnewwrmseventinfosearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
searchwrmseventinfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/searchwrmseventinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
getwrmseventinfoinitialdata(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/getwrmseventinfoinitialdata', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
downloadwrmseventinfo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/downloadwrmseventinfo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomerPolicySearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateCustomerPolicySearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
searchCustomerPolicy(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SearchCustomerPolicy', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createCustomerPayoutSearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreateCustomerPayoutSearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
searchCustomerPayout(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SearchCustomerPayout', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
downloadSearchBasedCustomerPayout(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/DownloadSearchBasedCustomerPayout', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
getCustomerBasedOnCustomerProofNo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/GetCustomerBasedOnCustomerProofNo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadCustomerPolicyListDocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/UploadCustomerPolicyListDocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadCustomerPolicyPayoutList(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/UploadCustomerPolicyPayoutList', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getCustomerApplicationListBasedOnCustomerProofNo(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/GetCustomerApplicationListBasedOnCustomerProofNo', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
downloadPolicyForWRMS(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/DownloadPolicyForWRMS', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
uploadWRMSDataWithPolicy(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/UploadWRMSDataWithPolicy', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
openWRMSDocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/OpenWRMSDocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
loadWRMSDocumnentsBasedOnWRMSScreenType(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/LoadWRMSDocumnentsBasedOnWRMSScreenType', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
createPayoutDocumentSearch(options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data.getData('Wrms/CreatePayoutDocumentSearch', options).pipe(
      finalize(() => this.data.serviceCompleted()),
      catchError((err) => {
        options.hideErrorMethod ? '' : this.data.errorMethod(err);
        return throwError(err);
      })
    );
}
  
searchPayoutDocument(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/SearchPayoutDocument', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getCustomerPolicyListDocumentByDocumentId(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/GetCustomerPolicyListDocumentByDocumentId', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getWrmsInfoListDocumentByDocumentId(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/GetWrmsInfoListDocumentByDocumentId', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
  
getCustomerPolicyPayoutListDocumentbydocumentId(body : any, options? : any): Observable<any> {
    this.data.serviceStarted();
    options === undefined
      ? (options = this.data.defaultOptions)
      : (options = this.data.setOptions(options));
    return this.data
      .postData('Wrms/getCustomerPolicyPayoutListDocumentbydocumentId', body, options)
      .pipe(
        finalize(() => this.data.serviceCompleted()),
        catchError((err) => {
          options.hideErrorMethod ? '' : this.data.errorMethod(err);
          return throwError(err);
        })
      );
}
 
}
